import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { ActivatedRoute } from '@angular/router';
import { Observable, Observer, map } from 'rxjs';
import { title } from 'process';
import { TranslateService } from '@ngx-translate/core';

export const configFactory = (config: IGovService): (() => Observable<boolean>) => {
    return () => config.getIP();
  };


@Injectable({
    providedIn: 'root'
})
export class IGovService {

    // globalIP:string;
    // globalIPUpdate:Observable<string>;
    // globalIPObserver:Observer<any>;

    // globalServerTime:any;
    // globalServerTimeUpdate:Observable<any>;
    // globalServerTimeObserver:Observer<any>;

    public headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/pdf' });
    serverTime;
    userIP
    constructor(private http: HttpClient,
        private transalateService: TranslateService, 
    ){
        // this.globalIPUpdate = new Observable((observer) => {
        //     this.globalIPObserver = observer;
        // });
        // this.globalServerTimeUpdate = new Observable((observer) => {
        //     this.globalServerTimeObserver = observer;
        // });
    }

    public get ip():string{
        return this.userIP;
      }
    public set ip(val: any){
        this.userIP = val;
    }

    setIp(ip){
        this.ip = ip;
    }

    getIp(){
        return this.ip;
    }

    getIP() {
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/get-ip`).pipe(
            map((resp: any)=>{
            window['ip'] = resp.ip;
            window['serverTime'] = resp.serverDate;
            setInterval(()=> {
                let date = new Date(window['serverTime']);
                window['serverTime'] = date.setSeconds(date.getSeconds() + 30);
            },30000)
            return true;
        }));
    }

    gaDefaultSession(){
        return '81';
    }

    getDocumentJosn(lang, docSymbol){
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/undoc?lang=${lang}&symbol=${docSymbol}`, {headers: this.headers});
    }

    menus(){
        return [
            {
                title: this.transalateService.instant('General Assembly'),
                activeIdentifire: 'ga',
                link: '',
                child: [
                    {
                        title: this.transalateService.instant('Plenary'),
                        link: `ga/plenary/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('First Committee'),
                        link: `ga/c1/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('Second Committee'),
                        link: `ga/c2/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('Third Committee'),
                        link: `ga/c3/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('Fourth Committee'),
                        link: `ga/c4/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('Fifth Committee'),
                        link: `ga/c5/${this.gaDefaultSession()}`
                    },
                    {
                        title: this.transalateService.instant('Sixth Committee'),
                        link: `https://www.un.org/en/ga/sixth/`
                    },
                    {
                        title: this.transalateService.instant('Biennial Meeting on Small Arms'),
                        link: `ga/bms/2026`
                    },
                    {
                        title: this.transalateService.instant('Disarmament Commission'),
                        link: `ga/undc/2026 Organizational Session`
                    },
                    {
                        title: this.transalateService.instant('Special Committee on Decolonization (C-24)'),
                        link: `ga/c24/2026`
                    },
                    {
                        title: this.transalateService.instant('Special Committee on Peacekeeping Operations (C-34)'),
                        link: `ga/c34/2026`
                    },
                    {
                        title: this.transalateService.instant('UNWRA Pledging Conference'),
                        link: `ga/unwrapc/2026`
                    },
                    {
                        title: this.transalateService.instant('Working Group on the Strengthening and Revitalizing of the Work of the General Assembly'),
                        link: `ga/wgsr/${this.gaDefaultSession()}`
                    },

                ]
            },
            {
                title: this.transalateService.instant('Economic and Social Council'),
                activeIdentifire: 'ecosoc',
                link: '/',
                child: [
                    {
                        title: this.transalateService.instant('Plenary'),
                        link: `/ecosoc/plenary/2027`
                    },
                    {
                        title: this.transalateService.instant('High-level political forum on sustainable development, convened under the auspices of the Council'),
                        link: `/ecosoc/hlpf/2026`
                    },{
                        title: this.transalateService.instant('Commission on Population and Development'),
                        link: '/ecosoc/cpd/59'
                    },
                    {
                        title: this.transalateService.instant('Commission for Social Development'),
                        link: `ecosoc/csocd/64`
                    },
                    {
                        title: this.transalateService.instant('Commission on the Status of Women'),
                        link: `/ecosoc/csw/70`
                    },
                    {
                        title: this.transalateService.instant('Committee of Experts on Global Geospatial Information Management'),
                        link: `/ecosoc/ggim/15`
                    },
                    {
                        title: this.transalateService.instant('Committee on Non-Governmental Organizations'),
                        link: `ecosoc/cngos/2026 Regular Session`
                    },
                    {
                        title: this.transalateService.instant('Forum on financing for development follow-up'),
                        link: `ecosoc/ffd/2026`
                    },
                    {
                        title: this.transalateService.instant('Permanent Forum on Indigenous Issues'),
                        link: `ecosoc/unpfii/25`
                    },
                    {
                        title: this.transalateService.instant('Statistical Commission'),
                        link: `ecosoc/statscomm/57`
                    },
                    {
                        title: this.transalateService.instant('United Nations Forum on Forests'),
                        link: `/ecosoc/unff/20`
                    },
                    {
                        title: this.transalateService.instant('United Nations Group of Experts on Geographical Names'),
                        link: `/ecosoc/ungegn/2025`
                    }
                    
                ]
            },
            {
                title: this.transalateService.instant('Conferences'),
                activeIdentifire: 'conferences',
                link: '/',
                child: [
                    {
                        title: this.transalateService.instant('FFD4'),
                        link: `/conferences/ffd4/2025`
                    },
                    {
                        title: this.transalateService.instant('FFD4 PrepCom'),
                        link: `/conferences/ffd4pc/3`
                    }
                ]
            }
        ]
    }
}
